import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
const AdvisorModalContext = /*#__PURE__*/ React.createContext({
    advisor: null,
    setAdvisor: ()=>null
});
export const useAdvisorModal = ()=>React.useContext(AdvisorModalContext);
export const AdvisorModalProvider = (param)=>{
    let { children  } = param;
    const [selectedAdvisor, setSelectedAdvisor] = useState(null);
    const handleSetAdvisor = useCallback((advisor)=>{
        setSelectedAdvisor(advisor);
    }, []);
    return /*#__PURE__*/ _jsx(AdvisorModalContext.Provider, {
        value: {
            advisor: selectedAdvisor,
            setAdvisor: handleSetAdvisor
        },
        children: children
    });
};
